import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import dotProps from 'dot-prop-immutable';

import * as pageActions from '../../../../../data/redux/page_details/actions';
import * as adminActions from '../../../../../data/redux/admin_details/actions';

import { IconFacebookSquare, IconTwitterSquare, IconLinkedinSquare } from '../../../../../data/assets/icons';
import { APP_PAGES } from '../../../../../data/config/constants';

import AvatarCard from '../../../../../components/avatarcard';
import CustomHeader from '../../../../../components/customheader';
import InputItem from '../../../../../components/form/inputitem';
import TextareaItem from '../../../../../components/form/textareaitem';
import SocialInputItem from '../../../../../components/form/socialinputitem';

function mapStateToProps(state) {
    return {
        admin_details: state.admin_details,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, pageActions, adminActions), dispatch)
    };
}

class ProfileSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: props.admin_details.user_info
        };
    }

    componentWillMount() {
        let { actions } = this.props;
        actions.pageChanged(APP_PAGES.PROFILE_SETTING, APP_PAGES.SETTINGS);
    }

    updateProfileState = (path, value) => {
        this.setState(dotProps.set(this.state, path, value));
    };

    resetProfileSetting = () => {
        const { admin_details } = this.props;
        this.updateProfileState('user', admin_details.user_info);
    };

    saveProfileSetting = () => {
        const payload = {
            updates: this.state.user,
        };
        this.props.actions.updateUserProfile(payload);
    };

    render() {
        const { user } = this.state;
        return (
            <Row className="ori-bg-default">
                <Col xs={24} sm={{ span: 22, offset: 1 }} md={{ span: 7, offset: 0 }} className="ori-pad-10">
                    <div className="ori-bg-white ori-box-shadow-light ori-lr-pad-10 ori-tb-pad-20">
                        <AvatarCard show_status show_sociallinks avatar_class="ori-box-75" title_class="ori-font-md ori-text-center" sub_title_class="ori-font-sm ori-font-light ori-text-center" title={`${user.firstName} ${user.lastName}`} sub_title={user.designation} email={user.email} is_verified={user.isVerified} is_active={user.isActive} is_deleted={user.isDeleted} bio={user.bio} facebook_url={user.socialLinks ? user.socialLinks.facebook : null} twitter_url={user.socialLinks ? user.socialLinks.twitter : null} linkedin_url={user.socialLinks ? user.socialLinks.linkedin : null} />
                    </div>
                </Col>
                <Col xs={24} sm={{ span: 22, offset: 1 }} md={{ span: 17, offset: 0 }} className="ori-lr-pad-10">
                    <CustomHeader title="Profile Setting" first_button_text="Reset" onClickFirstButton={this.resetProfileSetting} second_button_type="primary" second_button_text="Save" onClickSecondButton={this.saveProfileSetting} bottom_bordered show_first_button show_second_button />
                    <div className="ori-tb-mrgn-10 ori-full-width">
                        <p className="ori-font-md ori-b-mrgn-5">Tell us and your visitors a little bit about yourself</p>
                        <div className="ori-lr-pad-10 ori-tb-pad-5 ori-border-radius-4 ori-bg-white ori-box-shadow">
                            <Row gutter={16} className=" ori-b-pad-10">
                                <Col xs={24} sm={12}>
                                    <InputItem title="First Name" placeholder="First Name" value={user.firstName} onChange={(e) => this.updateProfileState('user.firstName', e.target.value)} />
                                </Col>
                                <Col xs={24} sm={12}>
                                    <InputItem title="Last Name" placeholder="Last Name" value={user.lastName} onChange={(e) => this.updateProfileState('user.lastName', e.target.value)} />
                                </Col>
                            </Row>
                            <Row gutter={16} className="ori-b-pad-10">
                                <Col xs={24} sm={12}>
                                    <InputItem title="Title / Designation" placeholder="Title / Designation" value={user.designation} onChange={(e) => this.updateProfileState('user.designation', e.target.value)} />
                                </Col>
                                <Col xs={24} sm={12}>
                                    <InputItem type="email" title="email" placeholder="Email" value={user.email} disabled />
                                </Col>
                            </Row>
                            <TextareaItem className="ori-border-radius-20 ori-font-md" title="A few words about yourself..." minRows={2} maxRows={4} placeholder="Something about yourself in 150 characters" value={user.bio} onChange={(e) => this.updateProfileState('user.bio', e.target.value)} />
                        </div>
                        <p className="ori-t-mrgn-10 ori-b-mrgn-5 ori-font-md">Add your social handles</p>
                        <div className="ori-bg-white ori-lr-pad-10 ori-tb-pad-5 ori-border-radius-4 ori-box-shadow">
                            <SocialInputItem Icon={IconFacebookSquare} icon_class="ori-font-facebook" icon_title="Facebook" type="url" placeholder="Enter your facebook url" value={user.socialLinks.facebook} onChange={(e) => this.updateProfileState('user.socialLinks.facebook', e.target.value)} />
                            <SocialInputItem Icon={IconTwitterSquare} icon_class="ori-font-twitter" icon_title="Twitter" type="url" placeholder="Enter your twitter url" value={user.socialLinks.twitter} onChange={(e) => this.updateProfileState('user.socialLinks.twitter', e.target.value)} />
                            <SocialInputItem Icon={IconLinkedinSquare} icon_class="ori-font-linkedin" icon_title="Linkedin" type="url" placeholder="Enter your linkedin url" value={user.socialLinks.linkedin} onChange={(e) => this.updateProfileState('user.socialLinks.linkedin', e.target.value)} />
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }
}

ProfileSetting.propTypes = {
    actions: PropTypes.object,
    admin_details: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(ProfileSetting);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/settings/profilesetting/index.js